import { IJsonQueryNewbuilding } from '../../../../../json_query';
import { ensureSingleTagExists } from '../../helpers';
import { ITagDefinition, TTag } from '../../index';

export const IGeoNewbuildingTagType = 'geo-newobject';

export interface IGeoNewbuildingTag {
  type: 'geo-newobject';
  value: number;
  text: string;
}

const isGeoNewbuildingTag = (tag: TTag): tag is IGeoNewbuildingTag => tag.type === IGeoNewbuildingTagType;

export const geoNewbuildingTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery, tagsData) => {
    const values =
      jsonQuery.geo &&
      (jsonQuery.geo.value.filter(geo => geo.type === 'newobject') as IJsonQueryNewbuilding[]).map(geo => geo.id);

    let nextTags = tags.filter(
      tag => tag.type !== IGeoNewbuildingTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce((result, value) => {
        const tagData = tagsData.newbuildings[value];

        return ensureSingleTagExists(
          result,
          (tag: TTag): tag is IGeoNewbuildingTag => isGeoNewbuildingTag(tag) && tag.value === value,
          () => ({
            type: IGeoNewbuildingTagType,
            value,
            text: tagData || 'Неизвестный ЖК',
          }),
        );
      }, nextTags);
    }

    return nextTags;
  },
};
